(function() {
  'use strict';
  
  const textStrings = window.smartCardStrings || {
    add: 'Ajouter',
    addToCart: 'Ajouter au panier',
    soldOut: 'Épuisé',
    added: 'Ajouté ✔'
  };

  const initLayoutObserver = () => {
    const observer = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const card = entry.target;
        if (entry.contentRect.width < 340) {
          card.classList.add('is-compact-layout');
        } else {
          card.classList.remove('is-compact-layout');
        }
      });
    });
    document.querySelectorAll('.smart-card').forEach(card => observer.observe(card));
  };

  const handleFormSubmit = (e) => {
    const form = e.target;
    if (form.tagName !== 'FORM') return;
    if (form.dataset.type !== 'add-to-cart-form') return;
    if (!form.closest('.smart-card')) return;
    
    const btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    
    const labelContainer = btn.querySelector('.js-btn-label');
    const originalHTML = labelContainer ? labelContainer.innerHTML : btn.innerHTML;
    
    btn.classList.add('is-loading');
    btn.disabled = true;

    const drawerLoading = document.querySelector('#mobile-drawer-loading');
    
    if (!drawerLoading) {
      setTimeout(() => finishAnimation(btn, labelContainer, originalHTML), 1800);
      return;
    }
    
    const checkDrawerDone = () => {
      const isHidden = window.getComputedStyle(drawerLoading).display === 'none' || 
                       drawerLoading.style.opacity === '0';
      if (isHidden) {
        clearInterval(checkInterval);
        finishAnimation(btn, labelContainer, originalHTML);
      }
    };
    
    const checkInterval = setInterval(checkDrawerDone, 100);
    
    setTimeout(() => {
      clearInterval(checkInterval);
      if (btn.classList.contains('is-loading')) {
        finishAnimation(btn, labelContainer, originalHTML);
      }
    }, 5000);
  };
  
  function finishAnimation(btn, labelContainer, originalHTML) {
    setTimeout(() => {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      if(labelContainer) labelContainer.innerHTML = `<span class="js-btn-text">${textStrings.added}</span>`;
      else btn.innerHTML = textStrings.added;
      setTimeout(() => {
        if(labelContainer) labelContainer.innerHTML = originalHTML;
        else btn.innerHTML = originalHTML;
      }, 2000);
    }, 300);
  }

  const formatMoney = (cents) => {
    if (!cents && cents !== 0) return '';
    const value = cents / 100;
    return (value % 1 === 0 ? value : value.toFixed(2)) + ' €'; 
  };

  const checkCardVariantAvailability = (card) => {
    const form = card.querySelector('variant-selects');
    if (!form) return;

    const jsonScript = form.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    const variants = JSON.parse(jsonScript.textContent);
    const fieldsets = Array.from(form.querySelectorAll('fieldset'));

    const selectedOptions = fieldsets.map(fieldset => {
      const checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : null;
    });

    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        let isAvailable = false;

        if (fieldsetIndex === 0) {
          isAvailable = variants.some(v => v.options[0] === input.value && v.available);
        } else {
          const testOptions = [...selectedOptions];
          testOptions[fieldsetIndex] = input.value;
          const match = variants.find(v =>
            testOptions.slice(0, fieldsetIndex + 1).every((val, idx) => val === v.options[idx])
          );
          isAvailable = match ? match.available : false;
        }

        if (isAvailable) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    });
  };

  let drawerStartY = 0;
  let drawerCurrentY = 0;
  let isDraggingDrawer = false;

  const handleClick = (e) => {
    const toggleBtn = e.target.closest('.js-toggle-variants');
    if (toggleBtn) {
      if(window.getComputedStyle(toggleBtn).display === 'none') return;
      e.preventDefault(); 
      e.stopPropagation(); 
      
      const card = toggleBtn.closest('.smart-card');
      document.querySelectorAll('.smart-card.variants-open').forEach(c => {
        if(c !== card) c.classList.remove('variants-open');
      });
      card.classList.add('variants-open');
      requestAnimationFrame(() => checkCardVariantAvailability(card));
    }
    
    if (e.target.matches('.js-close-variants')) {
      e.preventDefault(); 
      e.stopPropagation();
      e.target.closest('.smart-card').classList.remove('variants-open');
    }
    
    if (!e.target.closest('.smart-card__actions') && 
        !e.target.closest('.js-toggle-variants') && 
        !e.target.closest('.smart-card__variants-drawer')) {
      document.querySelectorAll('.smart-card.variants-open').forEach(c => c.classList.remove('variants-open'));
    }
  };

  const handleDrawerTouchStart = (e) => {
    const drawer = e.target.closest('.smart-card__variants-drawer');
    if (!drawer) return;
    const card = drawer.closest('.smart-card.variants-open');
    if (!card) return;
    if (e.target.closest('input, button, a, label')) return;
    isDraggingDrawer = true;
    drawerStartY = e.touches[0].clientY;
    drawer.classList.add('is-dragging');
  };

  const handleDrawerTouchMove = (e) => {
    if (!isDraggingDrawer) return;
    const drawer = e.target.closest('.smart-card__variants-drawer');
    if (!drawer) return;
    drawerCurrentY = e.touches[0].clientY;
    const delta = drawerCurrentY - drawerStartY;
    if (delta > 0) {
      drawer.style.transform = `translateY(${delta}px)`;
    }
  };

  const handleDrawerTouchEnd = (e) => {
    if (!isDraggingDrawer) return;
    const drawer = document.querySelector('.smart-card__variants-drawer.is-dragging');
    if (!drawer) return;
    const card = drawer.closest('.smart-card');
    const delta = drawerCurrentY - drawerStartY;
    isDraggingDrawer = false;
    drawer.classList.remove('is-dragging');
    if (delta > 100) {
      card.classList.remove('variants-open');
      drawer.style.transform = '';
    } else {
      drawer.style.transform = '';
    }
  };

  const handleVideoHoverEnter = (e) => {
    const card = e.target.closest('.smart-card');
    if (!card || card.classList.contains('is-soldout')) return;
    const video = card.querySelector('video.img-hover');
    if (video && video.paused) {
      video.play().catch(() => {});
    }
  };

  const handleVideoHoverLeave = (e) => {
    const card = e.target.closest('.smart-card');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    const video = card.querySelector('video.img-hover');
    if (video && !video.paused) {
      video.pause();
      video.currentTime = 0;
    }
  };

  const handleVariantChange = (e) => {
    if(!e.target.closest('.smart-card variant-selects')) return;
    
    const card = e.target.closest('.smart-card');
    const form = e.target.closest('variant-selects');
    const jsonScript = form.querySelector('script[type="application/json"]');
    if (!jsonScript) return;
    
    const variants = JSON.parse(jsonScript.textContent);
    const fieldsets = Array.from(form.querySelectorAll('fieldset'));
    const selectedOptions = fieldsets.map(fieldset => {
      const checkedInput = fieldset.querySelector('input:checked');
      return checkedInput ? checkedInput.value : null;
    });

    const currentVariant = variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    checkCardVariantAvailability(card);

    if (!currentVariant) {
      const drawerBtn = card.querySelector(".btn-add-drawer");
      if (drawerBtn) {
        drawerBtn.setAttribute("disabled", "true");
        drawerBtn.classList.add("is-soldout");
        const label = drawerBtn.querySelector(".js-btn-label");
        if (label) label.textContent = textStrings.soldOut;
      }
      return;
    }
    
    const mainImage = card.querySelector('.smart-card__media img');
    const newMedia = currentVariant.featured_media;
    if (mainImage && newMedia) {
      let newSrc = newMedia.preview_image ? newMedia.preview_image.src : newMedia.src;
      if(newSrc && newSrc.includes('/products/')) {
         const urlObj = new URL(newSrc);
         urlObj.pathname = urlObj.pathname.replace(/(\.[^.]*)$/, `_800x$1`);
         mainImage.src = urlObj.toString();
         mainImage.srcset = urlObj.toString(); 
      }
    }

    const allComparePrices = card.querySelectorAll('.js-btn-compare-price');
    const allPrices = card.querySelectorAll('.js-btn-price');
    const allBtns = card.querySelectorAll('.smart-card__btn-main'); 
    const allLabels = card.querySelectorAll('.js-btn-label');
    const hiddenInputs = card.querySelectorAll('input[name="id"]');
    
    hiddenInputs.forEach(input => input.value = currentVariant.id);

    if (currentVariant.available) {
        allBtns.forEach(btn => {
            btn.removeAttribute('disabled');
            btn.classList.remove('is-soldout');
        });
        allPrices.forEach(price => {
            price.style.display = 'inline';
            price.textContent = formatMoney(currentVariant.price);
            price.classList.toggle('price-is-sale', currentVariant.compare_at_price > currentVariant.price);
        });
        if (currentVariant.compare_at_price > currentVariant.price) {
            allComparePrices.forEach(compare => {
                compare.style.display = 'inline';
                compare.textContent = formatMoney(currentVariant.compare_at_price);
            });
        } else {
            allComparePrices.forEach(compare => compare.style.display = 'none');
        }
        allLabels.forEach(label => {
            if(label.closest('.btn-add-drawer')) {
               label.innerHTML = `<span class="js-btn-text">${textStrings.add}</span> <span class="js-btn-separator btn-separator">|</span> <span class="js-btn-price-in-btn">${formatMoney(currentVariant.price)}</span>`;
            } else if (!label.closest('.smart-card__btn-direct')) {
               label.textContent = textStrings.addToCart;
            }
        });
    } else {
        allBtns.forEach(btn => {
            if(!btn.classList.contains('smart-card__btn-direct')) {
               btn.setAttribute('disabled', 'true');
               btn.classList.add('is-soldout');
            }
        });
        allPrices.forEach(price => price.style.display = 'none');
        allComparePrices.forEach(compare => compare.style.display = 'none');
        allLabels.forEach(label => {
             if(label.closest('.btn-add-drawer')) label.textContent = textStrings.soldOut;
        });
    }
    
    const updateLink = (selector) => {
        const el = card.querySelector(selector);
        if (el) {
            const url = new URL(el.href, window.location.origin);
            url.searchParams.set('variant', currentVariant.id);
            el.href = url.toString();
        }
    };
    updateLink('.js-view-product-link');
    updateLink('.smart-card__btn-direct');
    updateLink('.smart-card__link-overlay'); 
    updateLink('.smart-card__media a');

  };

  const initPreorderBadges = () => {
    const badges = document.querySelectorAll('.badge-preorder[data-product-id]');
    if (!badges.length) return;

    const params = window.GloboPreorderParams || {};
    const shop = (params.shop) || 'bijo-paris.myshopify.com';
    const apiUrl = (params.apiUrl) || 'https://preorder.globo.io';

    badges.forEach(badge => {
      const productId = badge.dataset.productId;
      if (!productId) return;

      fetch(`${apiUrl}/api/preorder/shop/${shop}/product/${productId}`)
        .then(r => r.json())
        .then(data => {
          const msg = data?.message 
            || data?.preorder_message 
            || data?.note
            || data?.preorder?.message
            || data?.settings?.message
            || '';
          if (!msg) return;
          const textEl = badge.querySelector('.badge-preorder__text');
          if (textEl) textEl.textContent = msg;
          requestAnimationFrame(() => {
            badge.style.opacity = '1';
            badge.style.filter = 'blur(0)';
            badge.style.transform = 'scale(1)';
          });
        })
        .catch(() => {});
    });
  };

  document.addEventListener('submit', handleFormSubmit, true);
  document.addEventListener('click', handleClick);
  document.addEventListener('change', handleVariantChange);
  document.addEventListener('touchstart', handleDrawerTouchStart, { passive: true });
  document.addEventListener('touchmove', handleDrawerTouchMove, { passive: false });
  document.addEventListener('touchend', handleDrawerTouchEnd, { passive: true });
  document.addEventListener('mouseover', handleVideoHoverEnter);
  document.addEventListener('mouseout', handleVideoHoverLeave);
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initLayoutObserver();
      initPreorderBadges();
    });
  } else {
    initLayoutObserver();
    initPreorderBadges();
  }

})();